module.exports = __webpack_public_path__ + "img/HealthHelp_Articles.9ded1e90.svg";